import script from "./InfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoModal.vue?vue&type=script&setup=true&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=b84cccce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_06ebbe948ebbc1bd3ebd6c3aad4ab6ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b84cccce"]])

export default __exports__